/* eslint-disable react/require-default-props */
import 'date-fns';
import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { ptBR } from 'date-fns/locale';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
} from '@material-ui/pickers';

interface Props {
  style?: any;
  label: string;
  data?: Array<any>
  onChange: any;
  id: number;
  period: number;
  periodSelected: boolean;
}

const MaterialUIPickers: React.FC<Props> = ({
  style, label, id, onChange, data, periodSelected, period,
}) => {
  const handleDateChange = (date: any) => {
    onChange(data?.map((item) => {
      if (item.idDiaDaSemana === id) {
        if (label === 'Entrada') {
          item?.hours?.map((it: any) => {
            if (it.id === id && it.idTurno === period) {
              it.init = date;
              return it;
            }
            return it;
          });
          if (!item.hours.find((il: any) => il.id === id && il.idTurno === period)) {
            item.hours.push({ init: date, id, idTurno: period });
          }
        }
        if (label === 'Saída') {
          item?.hours?.map((it: any) => {
            if (it.id === id && it.idTurno === period) {
              it.end = date;
              return it;
            }
            return it;
          });
          if (!item.hours.find((il: any) => il.id === id && il.idTurno === period)) {
            item.hours.push({ end: date, id, idTurno: period });
          }
        }
      }
      return item;
    }));
  };

  const handleValue = () => {
    let values: string | null = null;

    data?.map((item) => {
      if (item.idDiaDaSemana === id) {
        if (label === 'Entrada') {
          item?.hours?.map((it: any) => {
            if (it.idTurno === period) {
              values = it.init;
              return it;
            }
            return it;
          });
          return item;
        }
        if (label === 'Saída') {
          item?.hours?.map((it: any) => {
            if (it.idTurno === period) {
              values = it.end === undefined ? null : it.end;
              return it;
            }
            return it;
          });
          return item;
        }
      }
      return item;
    });

    return values;
  };

  const handleTimePicker = () => (
    <KeyboardTimePicker
      value={handleValue()}
      disabled={!periodSelected}
      id="time-picker"
      inputVariant="outlined"
      label={label}
      size="small"
      style={style === undefined ? { marginTop: 10 } : style}
      invalidDateMessage="Horário em formato inválido."
      ampm={false}
      defaultValue="--:--"
      onChange={handleDateChange}
      KeyboardButtonProps={{
        'aria-label': 'change time',
      }}
    />
  );

  return (
    <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
      {handleTimePicker()}
    </MuiPickersUtilsProvider>
  );
};
export default MaterialUIPickers;
